import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=0bba56d5&scoped=true"
import script from "./choice.vue?vue&type=script&lang=ts"
export * from "./choice.vue?vue&type=script&lang=ts"
import style0 from "./choice.vue?vue&type=style&index=0&id=0bba56d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba56d5",
  null
  
)

export default component.exports